import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';

const InvitationResponse = () => {
  const { id } = useParams();
  const [invitation, setInvitation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [users, setUsers] = useState([]);

  const fetchUserData = async () => {
    try {
      const response = await axios.get(`https://api.lbnhyderabad.com/signup/get`);
      setUsers(response.data);

      setLoading(false);
    } catch (error) {
      console.error("There was an error fetching the data!", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);
  console.log(users)

  useEffect(() => {
    axios.get(`https://api.lbnhyderabad.com/signup/api/invitations/${id}`)
      .then((res) => {
        setInvitation(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, [id]);

  const handleResponse = (status) => {
    setUpdating(true);
    axios.put(`https://api.lbnhyderabad.com/signup/api/invitations/${id}/status`, { status })
      .then(() => {
        setInvitation((prev) => ({ ...prev, status }));
      })
      .catch((err) => console.error(err))
      .finally(() => setUpdating(false));
  };

  if (loading || !invitation) return <p>Loading...</p>;
  let statusColor;
  if (invitation.status === 1) {
    statusColor = '#28a745'; // Green for accepted
  } else if (invitation.status === 2) {
    statusColor = '#dc3545'; // Red for rejected
  } else {
    statusColor = '#ffc107'; // Yellow for pending
  }

// 👇 Add this just before return
const invitedUser = users.find(user => Number(user.id) === Number(invitation.userId));


  return (
    <div style={{
      padding: '20px',
      maxWidth: '500px',
      margin: '40px auto',
      background: '#fff',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      borderRadius: '10px',
      fontFamily: 'sans-serif'
    }}>
      <h2>{invitation.name}</h2>
      {/* <p><strong>Email:</strong> {invitation.email}</p> */}
      {invitedUser && (
        <div>
          <p><strong>{invitedUser.name}</strong> wants to have a one-to-one meeting with you</p>
          <p><strong>{invitedUser.name} Email:</strong> {invitedUser.email}</p>
        </div>
      )}

      <p><strong>Message:</strong> {invitation.message}</p>
      <p><strong>Date:</strong> {new Date(invitation.dateTime).toLocaleString()}</p>
      <p><strong>Status:</strong> {
        invitation.status === 1 ? '✅ Accepted' :
          invitation.status === 0 ? ' Pending' :
            invitation.status === 2 ? '❌ Rejected' :
              'Pending'
      }</p>

      {invitation.status === null || invitation.status === 0 ? (
        <div style={{ marginTop: '20px' }}>
          <button
            onClick={() => handleResponse(1)}
            disabled={updating}
            style={{
              marginRight: '10px',
              padding: '10px 20px',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            Accept
          </button>
          <button
            onClick={() => handleResponse(2)}
            disabled={updating}
            style={{
              padding: '10px 20px',
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            Reject
          </button>
        </div>
      ) : (
        <div style={{ marginTop: '20px', color: statusColor }}>
          You have {invitation.status === 1 ? 'accepted' :
            invitation.status === 2 ? 'rejected' :
              'pending'}
          this invitation.
        </div>
      )}
    </div>
  );
};

export default InvitationResponse;
